/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneArticleFooter from 'sites/allas/components/standalone/ArticleFooter';

export const DynamicStandaloneArticleFooter = StandaloneArticleFooter;
export type DynamicStandaloneArticleFooterProps = PropsFromComponent<typeof StandaloneArticleFooter>;

export const DynamicStandaloneArticleFooterWith = (extras: DynamicStandaloneExtras): typeof StandaloneArticleFooter => {
    return function DynamicStandaloneArticleFooter(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleFooter');
        return <StandaloneArticleFooter {...mergeProps({ options: { theme } }, props)} />;
    }
}